import { render } from "./vote-required-inputs.vue?vue&type=template&id=0a5682ed"
import script from "./vote-required-inputs.vue?vue&type=script&lang=js"
export * from "./vote-required-inputs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__